// extracted by mini-css-extract-plugin
export default {"wrapper":"mostConnected_wrapper__yJqyo","content":"mostConnected_content__-khMb","right_arrow":"mostConnected_right_arrow__CjLuK"};